import base from "../../base";
import userIsAdmin from "../Shared/functions/userIsAdmin";

export default async function addTreeToUser(uid, user, treeID, treeName) {
	if (!(await userIsAdmin(uid))) return;

	base.post(`treePermissions/${user}/${treeID}`, { data: treeName });
}
